import styled from 'styled-components';

export const UpdateSecurityCurrencyDrawerStyles = styled.div`
	height: 100%;

	form {
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
`;
